import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import account from "./module/account";
import document from "./module/document";
import enroll from "./module/enroll";
import invoice from "./module/invoice";
import auth from "./module/auth";
import error from "./module/error";

// 在路由跳转的时候同一个路由多次添加是不被允许的
// 重写路由的replace方法
const routerReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error => error);
};
// 重写路由的push方法
const originalPush = Router.prototype.push;
Router.prototype.push = function (location) {
  return originalPush.call(this, location).catch(error => error);
};

Vue.use(Router);

// 路由列表
const router = new Router({
  routes: [
    {
      path: "/",
      component: () => import("@/layout/default"),
      redirect: "/home",
      children: [...enroll, ...account],
    },
    ...invoice,
    ...document,
    ...error,
    ...auth,
    {
      path: "*",
      redirect: "/404",
    },
  ],
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 在部分页面，更新货币列表
  const needUpdateCurrencyPathList = [
    "/home",
    "/enroll",
    "/enroll/creation",
    // "/enroll/affirm",
    // "/enroll/details",
    "/enroll/notPaid",
    "/enroll/payment",
    "/invoice",
    "/unpaid",
    "/quotationV",
    "/amends",
    "/refund",
  ];
  if (needUpdateCurrencyPathList.includes(to.path)) {
    store.dispatch("currency/fetchCurrencyList").catch(() => {});
  }

  // 处理后台业务人员，通过跳转自动登录前台的情况
  const adminPathList = ["/login"];
  if (adminPathList.includes(to.path) && to.query.token) {
    return next();
  }

  const token = store.state.user.token;
  if (to.meta.requireAuth) {
    if (token) {
      const isCoordinator = store.state.user.isCoordinator;
      if (isCoordinator) {
        // 后台业务人员禁止修改邮箱和密码
        const forbiddenPaths = ["/email", "/password"];
        if (forbiddenPaths.includes(to.path)) {
          // 必须 return，防止继续向下执行
          return next("/403");
        }
      }
      return next();
    } else {
      // 未登录：检查是否是带凭证的特例页面
      const isSpecialPage = (to.path === "/enroll/details" || to.path === "/feeLetter") && to.query?.voucher;
      if (isSpecialPage) {
        return next();
      } else {
        return next("/login");
      }
    }
  } else {
    // 处理已登录用户强行访问登录页的情况
    const blacklist = ["/login", "/register", "/forget", "/reset"];
    if (blacklist.includes(to.path) && token) {
      return next("/");
    }
    return next();
  }
});

export default router;
